"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
const react_1 = require("react");
function useTimeout(ms = 250) {
    const [value, setValue] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    const timeout = (0, react_1.useCallback)(() => {
        if (ref.current) {
            return;
        }
        setValue(true);
        ref.current = setTimeout(() => {
            setValue(false);
            ref.current = null;
        }, ms);
    }, [ms]);
    return { value, timeout };
}
exports.useTimeout = useTimeout;
